/**
 * Coure.Hub.Service.Creation
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AllServicePartnerResponseDto } from '../model/allServicePartnerResponseDto';
import { MapServicePartnerRequestDto } from '../model/mapServicePartnerRequestDto';
import { ServicePartnerResponseDto } from '../model/servicePartnerResponseDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ServicePartnerService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServicePartnerGetAllServicePartnerGet(observe?: 'body', reportProgress?: boolean): Observable<AllServicePartnerResponseDto>;
    public apiServicePartnerGetAllServicePartnerGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AllServicePartnerResponseDto>>;
    public apiServicePartnerGetAllServicePartnerGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AllServicePartnerResponseDto>>;
    public apiServicePartnerGetAllServicePartnerGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<AllServicePartnerResponseDto>('get',`${this.basePath}/api/ServicePartner/getAllServicePartner`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param partnerId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServicePartnerGetServicePartnerByPartnerIdPartnerIdGet(partnerId: string, observe?: 'body', reportProgress?: boolean): Observable<ServicePartnerResponseDto>;
    public apiServicePartnerGetServicePartnerByPartnerIdPartnerIdGet(partnerId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ServicePartnerResponseDto>>;
    public apiServicePartnerGetServicePartnerByPartnerIdPartnerIdGet(partnerId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ServicePartnerResponseDto>>;
    public apiServicePartnerGetServicePartnerByPartnerIdPartnerIdGet(partnerId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (partnerId === null || partnerId === undefined) {
            throw new Error('Required parameter partnerId was null or undefined when calling apiServicePartnerGetServicePartnerByPartnerIdPartnerIdGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ServicePartnerResponseDto>('get',`${this.basePath}/api/ServicePartner/getServicePartnerByPartnerId/${encodeURIComponent(String(partnerId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServicePartnerGetServicePartnerByServiceIdServiceIdGet(serviceId: string, observe?: 'body', reportProgress?: boolean): Observable<ServicePartnerResponseDto>;
    public apiServicePartnerGetServicePartnerByServiceIdServiceIdGet(serviceId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ServicePartnerResponseDto>>;
    public apiServicePartnerGetServicePartnerByServiceIdServiceIdGet(serviceId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ServicePartnerResponseDto>>;
    public apiServicePartnerGetServicePartnerByServiceIdServiceIdGet(serviceId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (serviceId === null || serviceId === undefined) {
            throw new Error('Required parameter serviceId was null or undefined when calling apiServicePartnerGetServicePartnerByServiceIdServiceIdGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ServicePartnerResponseDto>('get',`${this.basePath}/api/ServicePartner/getServicePartnerByServiceId/${encodeURIComponent(String(serviceId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServicePartnerMapServicePartnerPost(body?: MapServicePartnerRequestDto, observe?: 'body', reportProgress?: boolean): Observable<ServicePartnerResponseDto>;
    public apiServicePartnerMapServicePartnerPost(body?: MapServicePartnerRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ServicePartnerResponseDto>>;
    public apiServicePartnerMapServicePartnerPost(body?: MapServicePartnerRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ServicePartnerResponseDto>>;
    public apiServicePartnerMapServicePartnerPost(body?: MapServicePartnerRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ServicePartnerResponseDto>('post',`${this.basePath}/api/ServicePartner/MapServicePartner`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
